import React from 'react';

function AppFooter() {
  return (
    <footer className="hr-footer">
      <span>© {new Date().getFullYear()} Ornnova HR Management</span>
      <span>Recruitment ERP • Secure Workforce Platform</span>
    </footer>
  );
}

export default AppFooter;
